import React from "react";
import Svg, { Path } from "react-native-svg";

function YourStoreIcon(props) {
  const { active = false, fill = "#777" } = props;

  const d = active
    ? "M17.16 3.8c-.09-.46-.5-.8-.98-.8H1.82c-.48 0-.89.34-.98.8L0 8v1c0 .55.45 1 1 1v5c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-5h4v5c0 .55.45 1 1 1s1-.45 1-1v-5c.55 0 1-.45 1-1V8l-.84-4.2zM9 14H3v-4h6v4zM2 2h14c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1z"
    : "M15.409 4.99l-.008-.04H2.599l-.008.04-.6 3-.012.06h14.042l-.012-.06-.6-3zM1.05 10v-.05H1A.95.95 0 01.05 9v-.901a.95.95 0 01.018-.186l.82-4.1a.95.95 0 01.932-.763h14.36a.95.95 0 01.932.764l.82 4.099a.955.955 0 01.018.186V9a.95.95 0 01-.95.95h-.05V15a.95.95 0 11-1.9 0V9.95h-4.1V15a.95.95 0 01-.95.95H2a.95.95 0 01-.95-.95v-5zm1.9 4v.05h6.1v-4.1h-6.1V14zM16 .05a.95.95 0 110 1.9H2a.95.95 0 010-1.9h14z";
  return (
    <Svg width={18} height={16} viewBox="0 0 18 16" fill="none" {...props}>
      <Path
        d={d}
        fill={active ? "#E40046" : fill}
        // fillOpacity={0.48}
        stroke="#fff"
        strokeWidth={0.1}
      />
    </Svg>
  );
}

export default YourStoreIcon;
